export default "__VITE_ASSET__c994e1e1__$_?nuxt_component=async__"